/* eslint eqeqeq: 0 */
import { combineReducers } from "redux";
import Immutable from "immutable";

import dateRange from "./dateRange";
import { Stat } from "../records/campaigns";
import { ManagerTopStat } from "../records/manager";
import * as constants from "../constants/overview";

function stat(
  state = { daily: new Immutable.List(), summary: new Stat() },
  action
) {
  if (action.type == constants.ON_LOAD_OVERVIEW_CAMPAIGN_STAT) {
    const daily = new Immutable.List(action.stat.stat).map(st => new Stat(st));
    const summary = new Stat(action.stat.summary);

    return { daily, summary };
  }

  return state;
}

function todayStat(state = new Stat(), action) {
  if (
    action.type == constants.ON_LOAD_OVERVIEW_TODAY_STAT &&
    action.stat.stat.length
  ) {
    return new Stat(action.stat.stat[0]);
  }

  return state;
}

const defaultSort = {
  key: "date",
  order: "desc"
};

function dataSort(state = defaultSort, action) {
  if (action.type == constants.SET_OVERVIEW_TABLE_SORT) {
    return {
      key: action.key,
      order: action.order
    };
  }
  return state;
}

function managerTopStat(state = {}, action) {
  if (action.type == constants.ON_LOAD_MANAGER_TOP_STAT) {
    return new ManagerTopStat(action.stat);
  }
  return state;
}

export default combineReducers({
  dateRange: dateRange(constants.SET_OVERVIEW_DATE_RANGE),
  stat,
  todayStat,
  dataSort,
  managerTopStat
});
